import axios from 'axios';

const adminUrl = process.env.VUE_APP_ADMIN_URL;

export default class TipoCambioService {
  static async getAll() {
    try {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      const response = await axios.get(`${adminUrl}/tipo-cambio`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      if (response.data.status === 'ok') {
        return { status: 'ok', data: response.data.data };
      }
      return { status: 'error' };
    } catch (error) {
      return { status: 'error' };
    }
  }

  static async updateRate(currency, rate) {
    try {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      const response = await axios.put(`${adminUrl}/tipo-cambio`, { currency, rate }, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      if (response.data.status === 'ok') {
        return { status: 'ok', data: response.data.data };
      }
      return { status: 'error' };
    } catch (error) {
      return { status: 'error' };
    }
  }
}
